import { CircleMarker, Popup } from 'react-leaflet';
import {
  monserratRegular,
  robotoRegular,
  scarpaGray900,
  scarpaGray500,
  scarpaGray200,
  electricPurple600,
  electricPurple900,
} from '@habitech/shared';

interface SubjectMarkerProps {
  lat: number | null;
  lng: number | null;
  nid: string;
}

export const SubjectMarker = ({ lat, lng, nid }: SubjectMarkerProps) => {
  if (lat == null || lng == null) return null;

  return (
    <CircleMarker
      center={[lat, lng]}
      radius={13}
      pathOptions={{
        fillColor: electricPurple600,
        color: electricPurple900,
        weight: 3,
        fillOpacity: 0.9,
      }}
    >
      <Popup>
        <div style={{ minWidth: '200px', fontFamily: robotoRegular }}>
          <p style={{
            fontWeight: 400,
            color: electricPurple600,
            fontSize: '13px',
            marginBottom: '6px',
            fontFamily: monserratRegular,
          }}>
            Inmueble Sujeto
          </p>
          <Row label="NID" value={nid} purple />
          <Row label="Latitud" value={String(lat)} />
          <Row label="Longitud" value={String(lng)} />
        </div>
      </Popup>
    </CircleMarker>
  );
};

const Row = ({
  label,
  value,
  purple,
}: {
  label: string;
  value: string;
  purple?: boolean;
}) => (
  <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '11px', margin: '3px 0', gap: '10px', fontFamily: robotoRegular }}>
    <span style={{ color: scarpaGray500 }}>{label}</span>
    <span style={{
      color: purple ? electricPurple600 : scarpaGray900,
      fontWeight: purple ? 700 : 500,
      textAlign: 'right',
    }}>
      {value}
    </span>
    <span style={{ display: 'none' }}>{scarpaGray200}</span>
  </div>
);
